// PGCET MCA Mock 7 — General Awareness (questions 71–90)
const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: "The Battle of Plassey, which laid the foundation of British rule in Bengal, was fought in",
    options: ["A. 1764", "B. 1757", "C. 1761", "D. 1857"],
    answer: "B"
  },
  {
    id: 72,
    question: "The Maurya Empire was founded by",
    options: ["A. Ashoka", "B. Bindusara", "C. Chandragupta Maurya", "D. Bimbisara"],
    answer: "C"
  },
  {
    id: 73,
    question: "Mahatma Gandhi began the Dandi March (Salt Satyagraha) in the year",
    options: ["A. 1920", "B. 1942", "C. 1919", "D. 1930"],
    answer: "D"
  },
  {
    id: 74,
    question: "The Jallianwala Bagh massacre of 1919 took place in",
    options: ["A. Amritsar", "B. Lahore", "C. Delhi", "D. Lucknow"],
    answer: "A"
  },
  {
    id: 75,
    question: "Who gave the slogan \"Do or Die\" during the Quit India Movement of 1942?",
    options: ["A. Subhas Chandra Bose", "B. Mahatma Gandhi", "C. Bal Gangadhar Tilak", "D. Bhagat Singh"],
    answer: "B"
  },
  {
    id: 76,
    question: "The Securities and Exchange Board of India (SEBI) was given statutory powers in",
    options: ["A. 1988", "B. 1995", "C. 1992", "D. 2000"],
    answer: "C"
  },
  {
    id: 77,
    question: "Gross Domestic Product measured at constant (base-year) prices is called",
    options: ["A. Real GDP", "B. Nominal GDP", "C. Gross National Product", "D. Net National Product"],
    answer: "A"
  },
  {
    id: 78,
    question: "The Green Revolution in India in the 1960s mainly led to a large increase in the production of",
    options: ["A. Pulses", "B. Oilseeds", "C. Wheat", "D. Jute"],
    answer: "C"
  },
  {
    id: 79,
    question: "Which Five Year Plan of India was based on the Mahalanobis model, emphasising heavy industries?",
    options: ["A. First Plan", "B. Second Plan", "C. Third Plan", "D. Fourth Plan"],
    answer: "B"
  },
  {
    id: 80,
    question: "The National Bank for Agriculture and Rural Development (NABARD) was established in",
    options: ["A. 1969", "B. 1975", "C. 1991", "D. 1982"],
    answer: "D"
  },
  {
    id: 81,
    question: "The Ranji Trophy is associated with",
    options: ["A. Cricket", "B. Hockey", "C. Football", "D. Badminton"],
    answer: "A"
  },
  {
    id: 82,
    question: "Neeraj Chopra won India's gold medal in athletics at the Tokyo Olympics in the event of",
    options: ["A. Shot put", "B. Discus throw", "C. Hammer throw", "D. Javelin throw"],
    answer: "D"
  },
  {
    id: 83,
    question: "How many players of each team are on the field in a standard game of field hockey?",
    options: ["A. 9", "B. 10", "C. 11", "D. 12"],
    answer: "C"
  },
  {
    id: 84,
    question: "The Durand Cup, one of the oldest tournaments of its kind in Asia, is associated with",
    options: ["A. Hockey", "B. Football", "C. Cricket", "D. Tennis"],
    answer: "B"
  },
  {
    id: 85,
    question: "The Jnanpith Award is given for outstanding contribution to",
    options: ["A. Literature", "B. Science", "C. Music", "D. Social service"],
    answer: "A"
  },
  {
    id: 86,
    question: "Who was the first Indian to be awarded a Nobel Prize?",
    options: ["A. C. V. Raman", "B. Mother Teresa", "C. Rabindranath Tagore", "D. Amartya Sen"],
    answer: "C"
  },
  {
    id: 87,
    question: "The Dadasaheb Phalke Award is conferred for lifetime contribution to",
    options: ["A. Literature", "B. Journalism", "C. Sports", "D. Indian cinema"],
    answer: "D"
  },
  {
    id: 88,
    question: "The State of Mysore was renamed Karnataka in the year",
    options: ["A. 1956", "B. 1973", "C. 1966", "D. 1980"],
    answer: "B"
  },
  {
    id: 89,
    question: "The monolithic statue of Gommateshwara (Bahubali) in Karnataka is located at",
    options: ["A. Shravanabelagola", "B. Badami", "C. Pattadakal", "D. Halebidu"],
    answer: "A"
  },
  {
    id: 90,
    question: "The Hoysala temples of Belur and Halebidu are located in which district of Karnataka?",
    options: ["A. Mysuru", "B. Chikkamagaluru", "C. Mandya", "D. Hassan"],
    answer: "D"
  }
];

export default pgcetmcaGeneralAwareness;
